import React from 'react';
import { EatinIcon, TakeawayIcon } from '@ordering/components/icons';

type Props = React.SVGAttributes<SVGElement> & {
  icon: string;
};

const Icon = React.forwardRef<SVGSVGElement, Props>(({ icon, ...props }, ref) => {
  switch (icon) {
    case 'EAT_IN':
      return <EatinIcon ref={ref} {...props} />;
    case 'TAKEAWAY':
      return <TakeawayIcon ref={ref} {...props} />;
    default:
      return null;
  }
});

Icon.displayName = 'Icon';

export default Icon;
